import { Element } from '@zmedia/bm-soccer-ui/components';
import cn from 'classnames';
import { memo } from 'react';
import { TournamentRanking } from '@zmedia/bm-soccer-ui/modules/tournament/views/ranking';
import styles from './style.module.scss';

export function RankingSidebar(props: any) {
    const { children } = props;
    return (
        <Element
            className={cn(
                styles[('tournament-table')],
                'min-w-[30rem] max-w-[32rem] empty:hidden',
                props.className
            )}
        >
            {children ? children : <TournamentRanking {...props} />}
        </Element>
    );
}

export default memo(RankingSidebar);
